class Zooming {
  previousCanvasScale: number;

  scaleOccurenceCount: number;

  scaleOccurenceThreshold: number;

  constructor() {
    this.previousCanvasScale = 0;
    this.scaleOccurenceCount = 0;
    this.scaleOccurenceThreshold = 5;
  }

  isZooming(): boolean {
    return this.scaleOccurenceCount < this.scaleOccurenceThreshold;
  }
}

export default Zooming;
